// Web Audio chime + voice announcement for received payments
let audioCtx = null;

function ctx() {
  if (!audioCtx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) audioCtx = new AC();
  }
  return audioCtx;
}

export function unlockAudio() {
  const c = ctx();
  if (c && c.state === "suspended") c.resume();
}

export function playChime() {
  const c = ctx();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  const now = c.currentTime;
  const notes = [784, 1047, 1319]; // G5, C6, E6 - bright success arpeggio
  notes.forEach((f, i) => {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = "sine";
    o.frequency.value = f;
    const t = now + i * 0.1;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.25, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, t + 0.5);
    o.connect(g);
    g.connect(c.destination);
    o.start(t);
    o.stop(t + 0.55);
  });
}

export function speakAmount(amount) {
  try {
    const synth = window.speechSynthesis;
    if (!synth) return;
    const rupees = Math.round(Number(amount));
    const u = new SpeechSynthesisUtterance(`Payment received, ${rupees} rupees`);
    u.rate = 0.95;
    u.pitch = 1.05;
    synth.speak(u);
  } catch (e) {
    /* ignore */
  }
}

export function announcePayment(amount) {
  playChime();
  setTimeout(() => speakAmount(amount), 450);
}
